import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "redux-little-router";
import PropTypes from "prop-types";
import mixpanel from "../../services/mixpanel";
import windowDataLayer from "../../util/windowDataLayer";

class SearchInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
    };
    this.updateValue = this.updateValue.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  render() {
    return (
      <input
        {...this.props}
        type="text"
        value={this.state.searchTerm}
        onKeyUp={this.handleSearch}
        onChange={this.updateValue}
      />
    );
  }

  updateValue(event) {
    event.preventDefault();
    event.persist();
    this.setState(prevState => ({
      ...prevState,
      searchTerm: event.target.value,
    }));
  }

  handleSearch(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      const searchTerm = this.state.searchTerm.trim();
      if (searchTerm.length > 0) {
        windowDataLayer.push({ event: "search", searchTerm });
        mixpanel.track("search", { searchTerm });
        this.props.actions.search(searchTerm);
        if (this.props.postSearchAction) {
          this.props.postSearchAction();
        }
      }
    }
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    search: searchTerm => dispatch(push(`/search?search_query=${searchTerm}`)),
  },
});

SearchInput.proptypes = {
  // A function for cleanups after search is triggered
  postSearchAction: PropTypes.func,
};

export default connect(
  null,
  mapDispatchToProps
)(SearchInput);



// WEBPACK FOOTER //
// ./src/components/SearchInput/index.js